import { isApiError } from "../api";

export function errorText(error: unknown, fallback = "The change didn't go through. Try again."): string {
  return isApiError(error) ? error.message : fallback;
}
